// import { useLingui } from '@lingui/react';
// import { Typography } from 'antd';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { styled } from 'styled-components';
import { StoredRushHour } from '~/gql/tracking-thematique/tracking-thematique';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const labels = [
  '0h',
  '1h',
  '2h',
  '3h',
  '4h',
  '5h',
  '6h',
  '7h',
  '8h',
  '9h',
  '10h',
  '11h',
  '12h',
  '13h',
  '14h',
  '15h',
  '16h',
  '17h',
  '18h',
  '19h',
  '20h',
  '21h',
  '22h',
  '23h',
];

type IProps = {
  rushHoursHm: StoredRushHour[];
  rushHoursIdeev: StoredRushHour[];
};

function Chart({ rushHoursHm, rushHoursIdeev }: IProps) {
  //   const { Text } = Typography;
  //   const { i18n } = useLingui();
  const [dataHoursIdeev, setDataHoursIdeev] = useState<StoredRushHour[]>([]);
  const [dataHoursHm, setDataHoursHm] = useState<StoredRushHour[]>([]);
  const [dataHours, setDataHours] = useState<StoredRushHour[]>([]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: false,
        text: "Affluence de l'application",
      },
    },
    scales: {
      y: {
        ticks: {
          stepSize: 1,
        },
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Affluence Ideev',
        data: dataHoursIdeev.map((el) => el.count),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: 'Affluence Henri Moissan',
        data: dataHoursHm.map((el) => el.count),
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
      {
        label: "Affluence pour l'app",
        data: dataHours.map((el) => el.count),
        borderColor: 'rgb(93, 235, 53)',
        backgroundColor: 'rgba(56, 235, 53, 0.5)',
      },
    ],
  };

  useEffect(() => {
    setDataHoursIdeev(getRushHoursFormatted(rushHoursIdeev));
    setDataHours(getRushHoursTotalFormatted(rushHoursHm, rushHoursIdeev));
    setDataHoursHm(getRushHoursFormatted(rushHoursHm));
  }, [rushHoursIdeev, rushHoursHm]);

  function getRushHoursFormatted(
    rushHours: StoredRushHour[]
  ): StoredRushHour[] {
    const _rushHours: StoredRushHour[] = [];
    for (let i = 0; i < 24; ++i) {
      const item: StoredRushHour = {
        hour: i,
        count: 0,
      };
      _rushHours.push(item);
    }
    for (const rh of rushHours) {
      const ind = _rushHours.findIndex((el) => el.hour === rh.hour);

      _rushHours[ind].count += rh.count;
    }
    return _rushHours;
  }

  function getRushHoursTotalFormatted(
    rushHours1: StoredRushHour[],
    rushHours2: StoredRushHour[]
  ): StoredRushHour[] {
    const _rushHours: StoredRushHour[] = [];
    for (let i = 0; i < 24; ++i) {
      const item: StoredRushHour = {
        hour: i,
        count: 0,
      };
      _rushHours.push(item);
    }
    for (const rh of rushHours1) {
      const ind = _rushHours.findIndex((el) => el.hour === rh.hour);
      _rushHours[ind].count += rh.count;
    }
    for (const rh of rushHours2) {
      const ind = _rushHours.findIndex((el) => el.hour === rh.hour);
      _rushHours[ind].count += rh.count;
    }
    return _rushHours;
  }

  return (
    <Container>
      <Line options={options} data={data} />
    </Container>
  );
}

export default Chart;

const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;
